<div
  class="container d-flex align-items-center justify-content-center"
  style="min-height: 100vh"
>
  <div class="row">
    <div class="col-md-11 mx-auto">
      <div class="card card-signing flex-row my-5" style="border-radius: 1rem">
        <div
          class="card-body"
          style="background-color: white; border-radius: 1rem; height: 100%"
        >
          <div class="row justify-content-center">
            <div class="col-12">
              <form class="px-4" action="">
                <div class="row" style="margin-top: 20px">
                  <!-- <p class="lead">Mulțumim că faci parte din comunitatea Ploom și că ne ajuți să fim mai buni.</p> -->
                  <p class="lead" [innerHTML]="surveyOutroText"></p>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-footer
  *ngIf="
    surveyType === 'PLOOM3_1' ||
    surveyType === 'PLOOM3_3' ||
    surveyType === 'PLOOM3_6' ||
    surveyType === 'PLOOM3_12'
  "
></app-footer>
